import _ from 'lodash'
import icon from 'scoreboard/components/icon'
import i18n from 'scoreboard/components/i18n'

export default function (iconId, label) {
	return _.constant(`${icon(iconId)}<h3>${i18n.get(label)}</h3>`)
}
